import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import UserStatus from './UserStatus';
import { useAuth } from '../AuthContext';
import '../Payment.css';
import API from '../api';

function Payment() {
  const { state } = useLocation();
  const selectedPlan = state?.selectedPlan;
  const [months, setMonths] = useState(1);
  const [saveMessage, setSaveMessage] = useState('');
  const [error, setError] = useState('');
  const { user } = useAuth();
  const navigate = useNavigate();
  const isSavingRef = useRef(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [loadingUserDetails, setLoadingUserDetails] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Proceed to Payment");
const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 769);
  
useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 769) {
        setSidebarOpen(true);  // open sidebar on desktop
      } else {
        setSidebarOpen(false); // closed on mobile
      }
    };

    handleResize(); // run on mount

    // Optional: listen for window resize to update sidebar automatically
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };
  
  useEffect(() => {
    document.title = "Payment | TradeBarta.com";
  }, []);


  useEffect(() => {
    if (!user?.id)
    { 
      console.log('User Id is not available');  
      return
    };
    fetchuserdetails();
  }, [user]);


  useEffect(() => {
    if (!selectedPlan) {
      console.warn('No plan selected — redirecting to pricing.');
      navigate('/pricing');
    }
  }, [selectedPlan, navigate]);

const fetchuserdetails = async () => {
  try {
    if (user?.id) {
      setLoadingUserDetails(true);
      const res = await API.get('/userdetails', { params: { user_id: user?.id } });
      setName(res.data.name || '');
      setEmail(res.data.email || '');
      setPhone(res.data.phone?.trim() || '');
    }
  } catch (err) {
    console.error('User load failed', err);
  } finally {
    setLoadingUserDetails(false); // ✅ Always set this
  }
};
  const generateInvoiceNumber = () => {
    const prefix = 'INV';
    const now = new Date();

    const datePart = now.toISOString().slice(0,10).replace(/-/g, ''); // YYYYMMDD
    const timePart = now.getTime().toString().slice(-5); // last 5 digits of timestamp
    const randomPart = Math.floor(Math.random() * 900 + 100); // random 3-digit number

    return `${prefix}-${datePart}-${timePart}-${randomPart}`;
  };

  const getNumericPrice = (priceString) => {
    const match = priceString.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  };

  const monthlyPrice = getNumericPrice(selectedPlan?.price || '');
  const totalAmount = monthlyPrice * months;

  const actions = selectedPlan?.action;
  const userId = user?.id;
  const planId = selectedPlan?.id;
  const planName = selectedPlan?.name;

  const handleChangePlan = () => {
    navigate('/change_plan');
  };

  const handlePayment = async (e) => {
    e.preventDefault();
     setIsLoading(true);
  setButtonText("Please Wait...");
 try {
    const invoiceNumber = generateInvoiceNumber();

    if (!invoiceNumber || !name || !email || !planName || !actions || !months || !totalAmount)
    {
      setError('Invalid or missing data.');
      return;
    }

    // Check if phone number is empty
  if (!phone?.trim()) {
    setPhoneError('Please enter phone number.');
    return;
  }

  // Optional: Check if phone number is valid
  if (!validatePhone(phone)) {
    setPhoneError('Please enter a valid Bangladeshi phone number.');
    return;
  }

    console.log('Initiating payment...');

    const res = await API.post('/api/paystation/initiate', {
      user_id: userId,
      package_id : planId,
      amount: totalAmount,
      invoice_number: invoiceNumber,
      months: months,
      currency: 'BDT',
      reference: '',
      cust_name: name,
      cust_phone: phone,
      cust_email: email,
      cust_address: '',
      action: actions,
      checkout_items: planName
    });

    const data = res.data;
    console.log('Payment Initiation Response:', data);

    if (data.status === 'success' && data.payment_url) 
    {
      window.location.href = data.payment_url; // Redirect user to payment gateway
    } 
    else 
    {
      console.log('Payment initiation failed: ' + (data.message || 'Unknown error'));
    }
    } catch (err) {
      console.error(err);
      console.log('Error initiating payment.');
      } finally {
        setIsLoading(false); // Re-enable the button after completion
        setButtonText("Proceed to Payment");
      }

  }

  const validatePhone = (number) => {
    const regex = /^01[3-9]\d{8}$/;
    return regex.test(number);
  };

const handlePhoneChange = (e) => {
  const value = e.target.value;
  setPhone(value);

  if (!validatePhone(value)) {
    setPhoneError('Please enter a valid Bangladeshi phone number.');
  } else {
    setPhoneError('');
  }
};

   /* const checkStatus = async () => {
    try {
      const res = await API.post('/api/paystation/status', {
        invoice_number: invoiceNumber,
      });

      setStatusInfo(res.data);
    } catch (err) {
      console.error(err);
      console.log('Error checking payment status.');
    }
  };
  */
  
  return (
  <div className='dashboard-wrapper'>
          {/* Top Navigation Bar */}
      <header className="header-container">
  <a href="/" className="logo">
    <img src={require("../images/logo.png")} alt="Logo" />
  </a>

                     
                    <button className="menu-toggle" onClick={toggleSidebar}>☰</button>  
     <UserStatus />
          </header>       
      {/* Sidebar and Main Content */}
                    
   <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
  
     <aside className={`sidebar ${sidebarOpen ? 'show-sidebar' : ''}`}>

          <ul>
            <li><a href="/dashboard">Dashboard</a></li>
            <li><a href="/payment_history">Billing and Payment History</a></li>
            <li><a href="/profile">My Profile</a></li>
            <li><a href="/contact_us">Support</a></li>
          </ul>
        </aside>

        <main className="main-content">
          <section className="data-table">
            <div className="form-column">
              <div className="subscription-container">
                <h3>
                  Confirm Your Plan
                  <button
                    className="btn"
                    style={{ backgroundColor: '#217dceff', marginLeft: '10px' }}
                    onClick={handleChangePlan}
                  >
                    Change Plan
                  </button>
                </h3>

                <div style={{
                  border: '1px solid #ccc',
                  borderRadius: '10px',
                  padding: '30px',
                  maxWidth: '400px',
                  margin: '30px auto',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                }}>
                  <h2 style={{ textAlign: 'center', fontSize: '28px', marginBottom: '10px' }}>
                    Selected Package - {selectedPlan?.name}
                  </h2>
                  <p style={{ fontSize: '24px', fontWeight: 'bold' }}>{selectedPlan?.price}</p>
                  <ul style={{
                    textAlign: 'left',
                    paddingLeft: '30px',
                    listStyleType: 'disc',
                    marginTop: '15px',
                    lineHeight: '1.6'
                  }}>
                    {selectedPlan?.features?.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>

      {!loadingUserDetails && !phone?.trim() && (
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <label htmlFor="phone" style={{ display: 'block', marginBottom: '5px' }}>
              Enter Your Phone Number:
            </label>
            <input
              id="phone"
              type="tel"
              placeholder="e.g., 017XXXXXXXX"
              value={phone}
              onChange={handlePhoneChange}
              required
              style={{
                padding: '10px',
                width: '100%',
                maxWidth: '300px',
                borderRadius: '5px',
                border: phoneError ? '1px solid red' : '1px solid #ccc',
                fontSize: '16px'
              }}
            />
            {phoneError && (
              <div style={{ color: 'red', marginTop: '5px' }}>{phoneError}</div>
            )}
          </div>
      )}
              <h4 style={{ textAlign: 'center', fontSize: '28px', marginBottom: '10px' }}>
                Select Subscription Duration
              </h4>

              <h3 className="sLabel">
                Duration:
                <select
                  className="sSelect"
                  value={months}
                  onChange={(e) => setMonths(parseInt(e.target.value, 10))}
                >
                  {[1, 3, 6, 12].map((m) => (
                    <option key={m} value={m}>{m} month{m > 1 ? 's' : ''}</option>
                  ))}
                </select>
              </h3>

              <p className="plan-price">Total Payable: Tk {totalAmount}</p>

              {error && <div className="error" style={{ color: 'red', marginTop: '10px' }}>{error}</div>}
              {saveMessage && <div className="message" style={{ marginTop: '10px' }}>{saveMessage}</div>}

              <div align="center">
                <button
                onClick={handlePayment}
                className="pay-button"
                style={{ marginTop: '20px' }}
                disabled={isLoading}
              >
                {buttonText}
              </button>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

export default Payment;
